import {
  getSimpleMovieList, rulesList, getHouseList, getOtherVersion, getVersion,
  getHouseListOptions
} from "@/helpers/service/api/common.js";
import { getShceduleList, getShceduleDetail } from "@/helpers/service/api/schedule.js";
import locale from "@/helpers/locale";
import moment from "moment";
import _ from "lodash";
const today = moment().startOf("day").valueOf();
export const createFormObj = () => {
  return {
    batchSchedule: {
      backNumber: 0,
      batchSchedule: false,
      endDate: 0,
      everyDateType: "DAYS",
      everyFew: 1,
      weekly: [],
    },
    couponTypeIds: [],
    // daysList: [],
    displayApp: true,
    displayPos: true,
    displaySelfCashier: true,
    displayWeb: true,
    displaySign: true,
    endTime: 0,
    filmId: "",
    freeSeat: false,
    houseCover: {
      congestionLevels: [],
      showSeatTypes: [],
    },
    houseId: "",
    hpPublish: "RELEASE",
    otherVersion: [],
    posStartSale: 0,
    // premium: 0,
    preRelease: true,
    publish: "RELEASE",
    startTime: 0,
    // standingArea: 0,
    // standingAreaSold: 0,
    subtitlesVersion: "",
    ticketRuleTemplateId: "",
    trailerTime: 0,
    version: "",
    webStartSale: 0,
    reflectDate: today,
    versionName: "",
  };
};

export const getScheduleDetail_fn = (id = "") => {
  const params = {
    id: id
  };

  if (id == "") {
    return new Promise(resolve => {
      resolve({});
    });
  }
  return new Promise((resolve, reject) => {
    getShceduleDetail(params, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });

};

export const getMovie = cinemaId => {
  return new Promise((resolve, reject) => {
    getSimpleMovieList({
      page: 0,
      pageSize: 9999,
      hiddenCms: false,
      status: "active",
      cinemaId: cinemaId,
      approve: true,
      field: ["id", "name", "durationMin"]
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getMovieListMap = cinemaId => {
  return new Promise((resolve, reject) => {
    getSimpleMovieList({
      page: 0,
      pageSize: 9999,
      status: "active",
      cinemaId: cinemaId,
      approve: true,
      field: ["id", "name", "parentFilmId", "versionMasterMsg", "durationMin", "trailerTimeMin"],
      hiddenCms: false
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getHouse = cinemaId => {
  const params = {
    page: 0,
    pageSize: 9999,
    status: "active",
    cinemaId: cinemaId,
  };

  return new Promise((resolve, reject) => {
    getHouseList(params, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getHouseOptions = cinemaId => {
  const params = {
    page: 0,
    pageSize: 9999,
    status: "active",
    cinemaId: cinemaId,
  };

  return new Promise((resolve, reject) => {
    getHouseListOptions(params, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
}
export const getVersion_fn = (cinemaId, page = 0, pageSize = 99999) => {
  return new Promise((resolve, reject) => {
    getVersion({ cinemaId: cinemaId, page, pageSize }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getOtherVersion_fn = (cinemaId, page = 0, pageSize = 99999) => {
  return new Promise((resolve, reject) => {
    getOtherVersion({ cinemaId: cinemaId, page, pageSize }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getRules = cinemaId => {
  const params = {
    page: 0,
    pageSize: 9999,
    status: "active",
    cinemaId: cinemaId,
  };

  return new Promise((resolve, reject) => {
    rulesList(params, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const formatDay = str => {
  let newStr = str;

  newStr = newStr.replace("-", locale("global.year"));
  newStr = newStr.replace("-", locale("global.month"));
  newStr += locale("global.day");

  return newStr;
};

export const getShceduleList_fn = params => {
  return new Promise((resolve, reject) => {
    getShceduleList(params, false, false).then(res => {
      if (res.data != null) {
        resolve(res);
      } else {
        resolve({ ...res, data: [], success: true });
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const formatFilmList = (scheduleList, filmList, subtitlesVersionOption) => {
  let newArr = [];
  let filmIds = [];

  scheduleList.map(scheduleItem => {
    const name = _.find(subtitlesVersionOption, item => item.value === scheduleItem.subtitlesVersion).text;
    let filmIndex = filmIds.indexOf(scheduleItem.filmId);
    let item = {
      scheduleId: scheduleItem.scheduleId,
      startTime: scheduleItem.showStartTime,
      endTime: scheduleItem.showEndTime,
      houseName: scheduleItem.houseName,
      scheduleStatus: scheduleItem.scheduleStatus,
      // approve: scheduleItem.approve,
      approve: scheduleItem.scheduleStatus == "release",
      onlineBookingUrl: scheduleItem.onlineBookingUrl,
      versionName: scheduleItem.versionName,
      subtitlesVersionName: name,
      otherVersionName: scheduleItem.otherVersion,
      freeSeat: scheduleItem.freeSeat,
      ticketRuleName: scheduleItem.ticketRuleName,
      mvtkCode: scheduleItem.mvtkCode,
      reflect: scheduleItem.reflect,
      reflectDate: scheduleItem.reflectDate,
      isChecked: scheduleItem.isChecked,
    };

    const _targetMovie = filmList.find(_movie => _movie.parentFilmId === scheduleItem.filmId || _movie.id === scheduleItem.filmId);
    const _cate = _targetMovie ? _targetMovie.category : "";

    if (filmIndex < 0) {
      let version = "";

      for (let i = 0; i < filmList.length; i++) {
        if (scheduleItem.filmId == filmList[i].id) {
          version = filmList[i].versionMasterMsg || "";
          break;
        }
      }

      filmIds.push(scheduleItem.filmId);
      newArr.push({
        filmId: scheduleItem.filmId,
        filmName: scheduleItem.filmName,
        version: version,
        items: [ item ],
        category: _cate,
      });
    } else {
      newArr[filmIndex].items.push(item);
    }
  });

  return newArr;
};

export const formatHouseList = (scheduleList, filmList, subtitlesVersionOption) => {
  let newArr = [];
  let houseName_arr = [];

  scheduleList.map(scheduleItem => {
    const name = _.find(subtitlesVersionOption, item => item.value === scheduleItem.subtitlesVersion).text;
    let houseIndex = houseName_arr.indexOf(scheduleItem.houseName);
    let version = "";
    let item = {
      scheduleId: scheduleItem.scheduleId,
      startTime: scheduleItem.showStartTime,
      endTime: scheduleItem.showEndTime,
      filmName: scheduleItem.filmName,
      version: "",
      scheduleStatus: scheduleItem.scheduleStatus,
      // approve: scheduleItem.approve,
      approve: scheduleItem.scheduleStatus == "release",
      onlineBookingUrl: scheduleItem.onlineBookingUrl,
      versionName: scheduleItem.versionName,
      subtitlesVersionName: name,
      otherVersionName: scheduleItem.otherVersion,
      freeSeat: scheduleItem.freeSeat,
      ticketRuleName: scheduleItem.ticketRuleName,
      mvtkCode: scheduleItem.mvtkCode,
      reflect: scheduleItem.reflect,
      reflectDate: scheduleItem.reflectDate,
      isChecked: scheduleItem.isChecked,
    };

    const _targetMovie = filmList.find(_movie => _movie.parentFilmId === scheduleItem.filmId || _movie.id === scheduleItem.filmId);
    const _cate = _targetMovie.category;

    for (let i = 0; i < filmList.length; i++) {
      if (scheduleItem.filmId == filmList[i].id) {
        version = filmList[i].versionMasterMsg || "";
        break;
      }
    }

    item.version = version;

    if (houseIndex < 0) {
      houseName_arr.push(scheduleItem.houseName);
      newArr.push({
        houseName: scheduleItem.houseName,
        items: [ item ],
        category: _cate,
      });
    } else {
      newArr[houseIndex].items.push(item);
    }
  });
  return newArr;
};

export const formatVersionList = (scheduleList, filmList, subtitlesVersionOption) => {
  let newArr = [];
  let subVersionName_arr = [];
  scheduleList.map(scheduleItem => {
    let subVersionIndex = subVersionName_arr.indexOf(scheduleItem.subtitlesVersion);
    let version = "";
    const name = _.find(subtitlesVersionOption, item => item.value === scheduleItem.subtitlesVersion).text;
    let item = {
      scheduleId: scheduleItem.scheduleId,
      startTime: scheduleItem.showStartTime,
      endTime: scheduleItem.showEndTime,
      filmName: scheduleItem.filmName,
      version: "",
      scheduleStatus: scheduleItem.scheduleStatus,
      // approve: scheduleItem.approve,
      approve: scheduleItem.scheduleStatus == "release",
      onlineBookingUrl: scheduleItem.onlineBookingUrl,
      versionName: scheduleItem.versionName,
      houseName: scheduleItem.houseName,
      subtitlesVersionName: name,
      otherVersionName: scheduleItem.otherVersion,
      freeSeat: scheduleItem.freeSeat,
      ticketRuleName: scheduleItem.ticketRuleName,
      mvtkCode: scheduleItem.mvtkCode,
      reflect: scheduleItem.reflect,
      reflectDate: scheduleItem.reflectDate,
      isChecked: scheduleItem.isChecked,
    };

    const _targetMovie = filmList.find(_movie => _movie.parentFilmId === scheduleItem.filmId || _movie.id === scheduleItem.filmId);
    const _cate = _targetMovie.category;

    for (let i = 0; i < filmList.length; i++) {
      if (scheduleItem.filmId == filmList[i].id) {
        version = filmList[i].versionMasterMsg || "";
        break;
      }
    }

    item.version = version;

    if (subVersionIndex < 0) {
      subVersionName_arr.push(scheduleItem.subtitlesVersion);
      const name = _.find(subtitlesVersionOption, item => item.value === scheduleItem.subtitlesVersion).text;
      newArr.push({
        versionName: name,
        items: [ item ],
        category: _cate,
      });
    } else {
      newArr[subVersionIndex].items.push(item);
    }
  });

  return newArr;
};

export const formatCalenderList = (scheduleList, startDay, filmList) => {
  let arr = [];
  // let startNum = parseInt(startDay);
  let cardBlock = [];

  scheduleList.map((scheduleItem, scheduleIndex) => {
    let startTime = scheduleItem.showStartTime;
    let endTime = scheduleItem.showEndTime;
    let version = "";

    // let thisNum = parseInt(moment(startTime).format("D")) - startNum;
    let thisNum = moment(startTime).diff(moment(startDay), "day");
    let startMin = parseInt(moment(startTime).format("HHmm"));
    let endMin = parseInt(moment(endTime).format("HHmm"));
    let cardHeight = 0;
    let top = 0;
    let cardPoint = {};
    let isNewBlock = true;

    if (endMin < startMin) {
      cardHeight = 2400 - startMin;
    } else {
      cardHeight = endMin - startMin;
    }

    cardHeight = (Math.floor(cardHeight / 100) * 60 + cardHeight % 100) * 2;// 一小时120px，一分钟2px
    top = (Math.floor(startMin / 100) * 60 + startMin % 100) * 2;

    for (let i = 0; i < filmList.length; i++) {
      if (scheduleItem.filmId == filmList[i].id) {
        version = filmList[i].versionMasterMsg || "";
        break;
      }
    }

    cardPoint.left = thisNum;
    cardPoint.yStart = top;
    cardPoint.yEnd = top + cardHeight;

    for (let i = 0; i < cardBlock.length; i++) {
      if (cardPoint.left == cardBlock[i].left) {
        if ((cardBlock[i].yStart < cardPoint.yStart && cardBlock[i].yEnd > cardPoint.yStart) || (cardBlock[i].yStart < cardPoint.yEnd && cardBlock[i].yEnd > cardPoint.yEnd) || (cardBlock[i].yStart >= cardPoint.yStart && cardBlock[i].yEnd <= cardPoint.yEnd)) {
          isNewBlock = false;
          let newYStart = cardBlock[i].yStart < cardPoint.yStart ? cardBlock[i].yStart : cardPoint.yStart;
          let newYEnd = cardBlock[i].yEnd > cardPoint.yEnd ? cardBlock[i].yEnd : cardPoint.yEnd;
          cardBlock[i].cardNum += 1;
          cardBlock[i].yStart = newYStart;
          cardBlock[i].yEnd = newYEnd;
          cardBlock[i].item.push(scheduleIndex);
          break;
        }
      }
    }

    if (isNewBlock) {
      cardBlock.push({
        ...cardPoint,
        cardNum: 1,
        item: [ scheduleIndex ],
      });
    }

    arr.push({
      style: {
        top: top + "px",
        left: `calc(${thisNum * 14}% + 1px)`,
        height: cardHeight + "px",
      },
      slot: {
        filmName: scheduleItem.filmName,
        startTime: startTime,
        endTime: endTime,
        version: version,
        houseName: scheduleItem.houseName,
        versionName: scheduleItem.versionName,
      },
      popover: {
        filmName: scheduleItem.filmName,
        startTime: startTime,
        endTime: endTime,
        version: version,
        houseName: scheduleItem.houseName,
        versionName: scheduleItem.versionName,
      },
      scheduleStatus: scheduleItem.scheduleStatus,
      // approve: scheduleItem.approve,
      approve: scheduleItem.scheduleStatus == "release",
      scheduleId: scheduleItem.scheduleId,
      onlineBookingUrl: scheduleItem.onlineBookingUrl,
    });
  });

  cardBlock.map(block => {
    let width = `calc(${14 / block.item.length}% - ${2 / block.item.length}px)`;

    block.item.map((scheduleIndex, index) => {
      let translateX = (index * 100) + "%";
      arr[scheduleIndex].style.width = width;
      arr[scheduleIndex].style.transform = `translateX(${translateX})`;
    });
  });

  return arr;
};

export const createShowScheduleList = (schedule, dayList, filmList, houseList) => {
  let scheduleList = [];
  let newSchedule = {
    approve: false,
    displayApp: schedule.displayApp,
    displayPos: schedule.displayPos,
    displaySelfCashier: schedule.displaySelfCashier,
    displayWeb: schedule.displayWeb,
    filmId: schedule.filmId,
    // filmName: "",
    filmVersion: schedule.version,
    // houseName: "",
    // scheduleId: "",
    scheduleStatus: schedule.scheduleStatus,
    // showEndTime: "",
    // showStartTime: "",
    versionName: schedule.versionName,
    reflect: schedule.reflect,
    reflectDate: schedule.reflectDate,

  };

  for (let i = 0; i < filmList.length; i++) {
    if (newSchedule.filmId == filmList[i].id) {
      newSchedule.filmName = filmList[i].name;
      break;
    }
  }

  for (let i = 0; i < houseList.length; i++) {
    if (schedule.houseId == houseList[i].id) {
      newSchedule.houseName = houseList[i].name;
      break;
    }
  }

  dayList.map(day => {
    scheduleList.push({
      ...newSchedule,
      scheduleId: moment(day + " " + schedule.startTime).valueOf(),
      showStartTime: moment(day + " " + schedule.startTime).valueOf(),
      showEndTime: moment(day + " " + schedule.endTime).valueOf(),
    });
  });

  return scheduleList;
};

export const createDayList = (batchSchedule = {}, startDay) => {
  let dayList = [];
  let afterDay = 0;
  let endDay = "";
  let startTime = moment(startDay).valueOf();
  let dayIndex = 0;
  let weekIndex = 0;

  if (batchSchedule.batchSchedule) {
    if (batchSchedule.endDate) {
      endDay = batchSchedule.endDate;
    } else {
      if (batchSchedule.everyDateType == "DAYS") {
        afterDay = parseInt(batchSchedule.backNumber) * (parseInt(batchSchedule.everyFew));
      } else {
        afterDay = parseInt(batchSchedule.backNumber) * parseInt(batchSchedule.everyFew) * 7 + 6 - moment(startDay).day();
      }

      endDay = moment(startDay).add(afterDay, "days").valueOf();
    }

    while (startTime <= endDay) {
      if (batchSchedule.everyDateType == "DAYS") {
        if (dayIndex % (parseInt(batchSchedule.everyFew)) == 0) {
          dayList.push(moment(startTime).format("YYYY-MM-DD"));
        }
      } else {
        let weekDayIndex = moment(startTime).day();

        // weekDayIndex = weekDayIndex == 0 ? 7 : weekDayIndex;

        if (weekDayIndex == 7 && dayIndex > 0) {
          weekIndex += 1;
        }

        if (batchSchedule.weekly.indexOf(weekDayIndex.toString()) >= 0 && weekIndex % (parseInt(batchSchedule.everyFew)) == 0) {
          dayList.push(moment(startTime).format("YYYY-MM-DD"));
        }
      }

      dayIndex += 1;
      startTime = startTime + 24 * 60 * 60 * 1000;
    }
  } else {
    dayList = [ startDay ];
  }

  return dayList;
};

// 验证命令中的日期是否合法
const isValidInputDate = dateString => {
  const parts = dateString.split("/");
  const day = parseInt(parts[1], 10);
  const month = parseInt(parts[0], 10);
  const year = new Date().getFullYear();
  const date = new Date(year, month - 1, day);
  return date && date.getMonth() + 1 === month && date.getDate() === day;
};
// 验证命令中的时间是否合法
const isValidInputTime = timeString => {
  const hours = parseInt(timeString.substring(0, 2), 10);
  const minutes = parseInt(timeString.substring(2, 4), 10);
  return hours >= 0 && hours < 30 && minutes >= 0 && minutes < 60;
};
// 验证命令
export const validCommand = (rule, value, callback) => {
  const regExp = /^[dr] ((\d{1,2}\/\d{1,2})(-\d{1,2}\/\d{1,2})?,?)+(\s((\d{4})(-\d{4})?(\/\d{4}(-\d{4})?)*)$)?/;
  if (!value) {
    callback();
  }
  if (regExp.test(value)) {
    const parts = value.split(" ");
    const [ commandType ] = parts;
    const dates = parts[1].split(",");
    const timeSegments = parts.length > 2 ? parts[2].split("/") : [];

    let datesValid = true;
    let datesComparisonValid = true;
    let allTimesValid = true;
    const allDates = [];

    // 对每个日期段进行处理
    dates.forEach(segment => {
      if (segment.includes("-")) {
        // 处理日期范围
        const _dates = segment.split("-");
        if (_dates.every(date => isValidInputDate(date))) {
          const startDate = new Date(_dates[0]);
          const endDate = new Date(_dates[1]);
          if (startDate.getTime() > endDate.getTime()) {
            datesComparisonValid = false;
          }
          allDates.push(..._dates);
        } else {
          datesValid = false;
        }
      } else {
        // 处理单个日期
        if (!isValidInputDate(segment)) {
          datesValid = false;
        }
        allDates.push(segment);
      }
    });
    if (commandType === "r" && timeSegments.length > 0) {
      // 验证时间段的有效性
      allTimesValid = timeSegments.every(segment => {
        const times = segment.split("-").map(time => time.trim());
        // 假设 isValidInputTime 函数存在且可以正确验证时间格式
        const segmentValid = times.every(time => isValidInputTime(time));
        if (times.length === 2 && segmentValid) {
          return times[0] < times[1];
        }
        return segmentValid;
      });
    } else if (commandType === "d" && parts.length > 2) {
      allTimesValid = false;
    }

    if (datesValid && allTimesValid && datesComparisonValid) {
      callback();
    } else {
      callback(new Error("日付または時刻の形式エラー 正しいコマンドを入力してください"));
    }
  } else {
    callback(new Error("正しいコマンドを入力してください"));
  }
};
// 将日期数组转化为字符串
// export const formatDates = dates => {
//   if (!dates || dates.length === 0) { return ""; }
//   dates.sort();
//   // 排序
//   const result = [];
//   // 初始化临时范围
//   let tempRange = [ convertToMMDD(dates[0]) ];

//   // 将字符串日期转换为Date对象
//   const dateObjects = dates.map(date => new Date(date));

//   for (let i = 1; i < dateObjects.length; i++) {
//     // 将当前日期转换为Date对象并格式化为MM/DD
//     const prevDate = new Date(dates[i - 1]);
//     const currentDate = new Date(dates[i]);
//     const formattedCurrentDate = convertToMMDD(dates[i]);

//     // 计算相邻日期的差异（毫秒为单位）
//     const diff = (currentDate - prevDate) / (1000 * 60 * 60 * 24);
//     if (diff === 1) {
//       // 如果当前日期紧接在前一个日期之后，将其添加到临时范围中
//       tempRange.push(formattedCurrentDate);
//     } else {
//       // 如果不连续，则处理之前的连续范围
//       if (tempRange.length > 1) {
//         // 如果临时范围包含多个日期，以起始-结束格式添加
//         result.push(`${tempRange[0]}-${tempRange[tempRange.length - 1]}`);
//       } else {
//         // 只有一个日期，直接添加
//         result.push(tempRange[0]);
//       }
//       // 重置临时范围为当前日期
//       tempRange = [ formattedCurrentDate ];
//     }
//   }

//   // 处理数组末尾的日期范围
//   if (tempRange.length > 1) {
//     result.push(`${tempRange[0]}-${tempRange[tempRange.length - 1]}`);
//   } else {
//     result.push(tempRange[0]);
//   }

//   return result.join(", ");
// };

// 将日期转化为MM/DD
const convertToMMDD = (dateStr) => {
  const date = new Date(dateStr);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
};
// 将日期数组转化为字符串
export const formatDates = (dates) => {
  if (!dates || dates.length === 0) return '';
  dates.sort();
  // 排序
  const result = [];
  console.log(dates);
  // 初始化临时范围
  let tempRange = [convertToMMDD(dates[0])];
  console.log(tempRange);

  // 将字符串日期转换为Date对象
  const dateObjects = dates.map((date) => new Date(date));

  for (let i = 1; i < dateObjects.length; i++) {
    // 将当前日期转换为Date对象并格式化为MM/DD
    const prevDate = new Date(dates[i - 1]);
    const currentDate = new Date(dates[i]);
    const formattedCurrentDate = convertToMMDD(dates[i]);

    // 计算相邻日期的差异（毫秒为单位）
    const diff = (currentDate - prevDate) / (1000 * 60 * 60 * 24);
    if (diff === 1) {
      // 如果当前日期紧接在前一个日期之后，将其添加到临时范围中
      tempRange.push(formattedCurrentDate);
    } else {
      // 如果不连续，则处理之前的连续范围
      if (tempRange.length > 1) {
        // 如果临时范围包含多个日期，以起始-结束格式添加
        result.push(`${tempRange[0]}-${tempRange[tempRange.length - 1]}`);
      } else {
        // 只有一个日期，直接添加
        result.push(tempRange[0]);
      }
      // 重置临时范围为当前日期
      tempRange = [formattedCurrentDate];
    }
  }

  // 处理数组末尾的日期范围
  if (tempRange.length > 1) {
    result.push(`${tempRange[0]}-${tempRange[tempRange.length - 1]}`);
  } else {
    result.push(tempRange[0]);
  }

  return result.join(', ');
};

